import isTablet from './isTablet'
import isMobile from './isMobile'

/**
 * Ez egy handheld (kézi), vagy tablet/mobil eszköz, vagy CORDOVA-val buildelünk?
 * @param ua - A böngésző által a kiszolgálónak küldött User-agent header.
 */
export default function isHandheld (ua: string): boolean {
  return isTablet(ua) || isMobile(ua)
}
